import { initWsgenv } from '@didi/wsgsdk'
import queryString from 'query-string'
import wsgConfig from './wsgConfig'

export const initWsgSDK = function () {
  const { appId, env, uid } = wsgConfig.online
  try {
    const wsgInstance = initWsgenv({
      appId,
      env,
      uid,
      wsgenvType: 'common', // 初始化成功前也有wsgenv返回
    })
    window.WsgInstance = wsgInstance
    return wsgInstance
  } catch {}
}
class WsgEnv {
  constructor() {
    this.wsgenv = ''
  }

  getWsgEnv({ url, bfield = {} }) {
    return new Promise((resolve, reject) => {
      try {
        if (window?.WsgInstance) {
          window?.WsgInstance?.wsgParams({ url, bfield }, wsgenv => {
            this.wsgenv = wsgenv
            resolve(wsgenv)
          })
        } else {
          resolve()
        }
      } catch {
        reject()
      }
    })
  }

  async wsgEnvToQuery(config) {
    await this.getWsgEnv({ url: config.url })
    config.params.wsgenv = this.wsgenv
    return config
  }

  async wsgEnvToBody(config) {
    await this.getWsgEnv({ url: config.url })
    if (!this.wsgenv) return config
    const params = this.getDataObject(config.data)
    params.wsgenv = this.wsgenv
    config.data = this.setDataString(params)
    return config
  }

  getDataObject(data) {
    return queryString.parse(data)
  }

  setDataString(data) {
    return queryString.stringify(data)
  }

  async wsgEnvToServer(config) {
    try {
      await this.wsgEnvToBody(config)
      // await this.wsgEnvToQuery(config)
      return config
    } catch (error) {
      console.error('wsgEnvToServer 执行异常:', error)
      return config
    }
  }
}

// let wsgEnv = new WsgEnv(wsgConfig.online);
let wsgEnv = new WsgEnv(wsgConfig.online)

export default wsgEnv
